export const toNonEmptyArray = <T>(array: T[]): [T, ...T[]] => {
    if (array.length === 0) {
        throw new Error('Array must have at least one element');
    }
    return array as [T, ...T[]];
};
